import { Avatar } from "@mui/material";
import { useSocialMediaThemes } from "../../api/getSocialMediaThemes";
import { baseUrl } from "../../../../shared/config";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { Home, Policy } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { useTenantParameters } from "../../../misc/api/getTenantParameters";
import _cookies from "../../../../shared/utils/_cookies";

const ITEM_WIDTH = "68";

export const useThemesListStyles = makeStyles((theme) => ({
  feed_mobile_header: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    position: "relative",
    flexDirection: "row",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    padding: `${theme.spacing(1)} 1px`,

    overflow: "auto",
  },

  themes_list: {
    display: "flex",
  },
  themes_list_item: {
    padding: "2px 6px",
    width: `${ITEM_WIDTH}px`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
  },
  themes_list_item_home: {
    backgroundColor: theme.palette.primary.main,
  },
  themes_list_item_text: {
    fontSize: "10px",
    width: "100%",
    overflow: "hidden",
    display: "-webkit-box",
    justifyContent: "center",
    wordWrap: "overflow-wrap",
    textAlign: "center",
    "-webkit-line-clamp": "2",
    "-webkit-box-orient": "vertical",
  },
  themes_list_item_avatar: {
    height: "56px",
    width: "56px",
  },
  avatar_bordered: {
    border: `3px solid ${theme.palette.primary.light}`,
  },
  arrow_button: {
    position: "absolute",
    backgroundColor: "white",
    top: "20px",
  },
  arrow_button_left: { left: "6px" },
  arrow_button_right: {
    right: "6px",
  },
}));

export default function MobileHeader({ children }) {
  const { data } = useSocialMediaThemes();
  const [searchParams] = useSearchParams();
  const tenantParamsQ = useTenantParameters();
  const location = useLocation();
  const hideThemes = searchParams.get("hideThemes") === "true";
  const classes = useThemesListStyles();
  const params = useParams();
  const navigate = useNavigate();
  const handleClickItem = (item) => () => {
    if (item === "moderar") {
      navigate(`../social/tema/${params.themeId || 0}/moderar`);
      return;
    }
    if (!item) {
      navigate(`../social`);
      return;
    }
    navigate(`../social/tema/${item.TEMAID}`);
  };

  const isThemeSelected = (themeId) => {
    return (
      themeId === Number(params.themeId) &&
      !location.pathname.includes("moderar")
    );
  };
  const showModerationButtons = () => {
    if (
      tenantParamsQ.data?.EXIGIR_APROVACAO_REDE_SOCIAL === "S" &&
      _cookies.getItem("auth").user?.profile?.isGestor?.ID
    ) {
      return true;
    }
    return false;
  };
  return (
    <div
      className={clsx({
        [classes.feed_mobile_header]: !hideThemes,
        hidden: hideThemes,
      })}
    >
      <ul className={classes.themes_list}>
        {showModerationButtons() && (
          <li
            className={classes.themes_list_item}
            disablePadding
            sx={{ paddingY: 1 }}
            onClick={handleClickItem("moderar")}
          >
            <Avatar
              className={clsx({
                [classes.themes_list_item_avatar]: true,
                [classes.avatar_bordered]:
                  location.pathname.includes("moderar"),
                [classes.themes_list_item_home]: true,
              })}
              href={`/aluno/social/tema/${params.themeId || 0}/moderar`}
            >
              <Policy />
            </Avatar>
            <span
              className={clsx({
                [classes.themes_list_item_text]: true,
                "font-bold": location.pathname.includes("moderar"),
              })}
            >
              Moderar este tema
            </span>
          </li>
        )}
        <li
          className={classes.themes_list_item}
          disablePadding
          sx={{ paddingY: 1 }}
          onClick={handleClickItem(null)}
        >
          <Avatar
            className={clsx({
              [classes.themes_list_item_avatar]: true,
              [classes.avatar_bordered]: isThemeSelected(),
              [classes.themes_list_item_home]: true,
            })}
          >
            <Home />
          </Avatar>
          <span
            className={clsx({
              [classes.themes_list_item_text]: true,
              "font-bold": isThemeSelected(),
            })}
          >
            Feed Geral
          </span>
        </li>
        {data?.map((theme) => {
          return (
            <li
              className={classes.themes_list_item}
              onClick={handleClickItem(theme)}
            >
              <Avatar
                className={clsx({
                  [classes.themes_list_item_avatar]: true,
                  [classes.avatar_bordered]: isThemeSelected(theme.TEMAID),
                })}
                src={`${baseUrl}/membros/fotos/${theme?.FOTO}`}
              />

              <span
                className={clsx({
                  [classes.themes_list_item_text]: true,
                  "font-bold": isThemeSelected(theme.TEMAID),
                })}
              >
                {theme.NOME}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
